import React from 'react';
import { Article } from 't2-graphql-types';
import Image from 'next/legacy/image';
import cx from 'classnames';
import { linkHoverClassNames } from 'utils/linkHoverClassNames';
import Typo from '../Typography';
import getManageArticleUrl from '../ArticleCard/services/getManageArticleUrl';

export type TArticleHeaderProps = Pick<Required<Article>, 'id' | 'title'>;

export const ArticleEditButton = ({ id = '' } = {}) => (
  <a
    className="absolute top-0 right-0 lg:-right-32 lg:top-1/3 flex h-[30px] items-center"
    href={getManageArticleUrl(id)}
  >
    <Image alt="edit icon" src="/images/edit-pencil-orange.svg" width={30} height={30} />
    <span className={cx('font-semibold text-[14px] text-orange-500', linkHoverClassNames)}>Edit article</span>
  </a>
);

const ArticleHeader: React.FC<TArticleHeaderProps> = ({ title }) => (
  <Typo
    variant="h1"
    className="my-9 lg:my-16 md:!text-[60px] md:!leading-[64px] lg:!text-[80px] lg:!leading-[86px] text-black-700 text-center break-words"
    text={title}
  />
);
export default ArticleHeader;
